// src/models/financeiro/DashFinanceiro.js
const dataLocal = (data) => `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}-${String(data.getDate()).padStart(2, '0')}`;

export const periodoFinanceiroPadrao = (hoje = new Date()) => ({
  dataIni: dataLocal(new Date(hoje.getFullYear(), hoje.getMonth(), 1)),
  dataFim: dataLocal(hoje),
});

export const validarPeriodoFinanceiro = ({ dataIni, dataFim }) => {
  if (!dataIni || !dataFim) return 'Informe a data inicial e a data final.';
  if (dataIni > dataFim) return 'A data inicial deve ser anterior ou igual à data final.';
  return '';
};

export const linkContasEmAberto = (filialId, cliente) => {
  const parametros = new URLSearchParams({ origem: 'dashFinanceiro', filialId: String(filialId), statusRec: '4' });
  if (cliente?.clienteId) {
    parametros.set('clienteId', String(cliente.clienteId));
    parametros.set('clienteNome', cliente.nomeCliente);
  }
  return `/recebimento?${parametros.toString()}`;
};

export const formatarDataFinanceiro = (valor, mensal = false) => {
  if (!valor) return '—';
  const [ano, mes, dia] = String(valor).split('T')[0].split('-');
  return mensal ? `${mes}/${ano}` : `${dia}/${mes}/${ano}`;
};

export default class DashFinanceiro {
  constructor(dados = {}) {
    Object.assign(this, dados);
    this.indicadores = {
      saldoAReceber: 0, parcelasEmAberto: 0, valorEmAtraso: 0, parcelasEmAtraso: 0,
      percentualEmAtraso: 0, valorVenceHoje: 0, parcelasVenceHoje: 0,
      valorProximosSeteDias: 0, parcelasProximosSeteDias: 0,
      valorRecebidoPeriodo: 0, pagamentosPeriodo: 0, clientesEmAtraso: 0,
      ...dados.indicadores,
    };
    this.recebimentos = dados.recebimentos || [];
    this.formasPagamento = dados.formasPagamento || [];
    this.faixasAtraso = dados.faixasAtraso || [];
    this.clientes = dados.clientes || [];
    this.vencimentos = dados.vencimentos || [];
  }

  get temDados() {
    return Number(this.indicadores.parcelasEmAberto || 0) > 0 || Number(this.indicadores.pagamentosPeriodo || 0) > 0;
  }
}
